// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"ProductImage_placeholder__2-_eH"};